import { DateTime } from 'luxon'

export const formatDate = (timestamp, timezone) => {
  if (!timestamp) return ''
  return DateTime.fromSeconds(timestamp.seconds, { zone: timezone }).toLocaleString()
}